import { createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "accordion",
  id: "accordionDeviceForm"
}
const _hoisted_2 = { class: "accordion-item" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", {
  class: "accordion-header",
  id: "headingDeviceForm"
}, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseDeviceForm",
    "aria-expanded": "true",
    "aria-controls": "collapseDeviceForm"
  }, " Alta de Dispositivo ")
], -1)
const _hoisted_4 = {
  id: "collapseDeviceForm",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingDeviceForm",
  "data-bs-parent": "#accordionDeviceForm"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "MAC", -1)
const _hoisted_8 = { class: "col-lg-8 fv-row" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Wifi Module", -1)
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Cliente (opcional)", -1)
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: null }, "-- Sin cliente --", -1)
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Seleccionar Modelo", -1)
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Submit")
], -1)
const _hoisted_20 = {
  class: "accordion",
  id: "accordionClientForm"
}
const _hoisted_21 = { class: "accordion-item" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h2", {
  class: "accordion-header",
  id: "headingClientForm"
}, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseClientForm",
    "aria-expanded": "true",
    "aria-controls": "collapseClientForm"
  }, " Alta de Cliente ")
], -1)
const _hoisted_23 = {
  id: "collapseClientForm",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingClientForm",
  "data-bs-parent": "#accordionClientForm"
}
const _hoisted_24 = { class: "card-body border-top p-9" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Client Name", -1)
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Client Email", -1)
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Submit")
], -1)
const _hoisted_32 = {
  class: "accordion",
  id: "accordionDistributorForm"
}
const _hoisted_33 = { class: "accordion-item" }
const _hoisted_34 = /*#__PURE__*/_createVNode("h2", {
  class: "accordion-header",
  id: "headingDistributorForm"
}, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseDistributorForm",
    "aria-expanded": "true",
    "aria-controls": "collapseDistributorForm"
  }, " Alta de Distribuidor ")
], -1)
const _hoisted_35 = {
  id: "collapseDistributorForm",
  class: "accordion-collapse collapse ",
  "aria-labelledby": "headingDistributorForm",
  "data-bs-parent": "#accordionDistributorForm"
}
const _hoisted_36 = { class: "card-body border-top p-9" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Distributor Name", -1)
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Select Clients", -1)
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Submit")
], -1)
const _hoisted_44 = {
  class: "accordion",
  id: "accordionAssociateDeviceClient"
}
const _hoisted_45 = { class: "accordion-item" }
const _hoisted_46 = /*#__PURE__*/_createVNode("h2", {
  class: "accordion-header",
  id: "headingAssociateDeviceClient"
}, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseAssociateDeviceClient",
    "aria-expanded": "true",
    "aria-controls": "collapseAssociateDeviceClient"
  }, " Asociar Dispositivo con Cliente ")
], -1)
const _hoisted_47 = {
  id: "collapseAssociateDeviceClient",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingAssociateDeviceClient",
  "data-bs-parent": "#accordionAssociateDeviceClient"
}
const _hoisted_48 = { class: "card-body border-top p-9" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Dispositivo (MAC)", -1)
const _hoisted_51 = { class: "col-lg-8 fv-row position-relative" }
const _hoisted_52 = {
  key: 0,
  class: "combo-list border rounded bg-white position-absolute w-100",
  style: {"z-index":"10","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_53 = {
  key: 1,
  class: "combo-list border rounded bg-white position-absolute w-100 px-2 py-1 text-muted",
  style: {"z-index":"10"}
}
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Cliente", -1)
const _hoisted_56 = { class: "col-lg-8 fv-row position-relative" }
const _hoisted_57 = {
  key: 0,
  class: "combo-list border rounded bg-white position-absolute w-100",
  style: {"z-index":"10","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_58 = {
  key: 1,
  class: "combo-list border rounded bg-white position-absolute w-100 px-2 py-1 text-muted",
  style: {"z-index":"10"}
}
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Asociar")
], -1)
const _hoisted_60 = {
  class: "accordion",
  id: "accordionModelForm"
}
const _hoisted_61 = { class: "accordion-item" }
const _hoisted_62 = /*#__PURE__*/_createVNode("h2", {
  class: "accordion-header",
  id: "headingModelForm"
}, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseModelForm",
    "aria-expanded": "true",
    "aria-controls": "collapseModelForm"
  }, " Alta de Modelo ")
], -1)
const _hoisted_63 = {
  id: "collapseModelForm",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingModelForm",
  "data-bs-parent": "#accordionModelForm"
}
const _hoisted_64 = { class: "card-body border-top p-9" }
const _hoisted_65 = { class: "row mb-6" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Modelo", -1)
const _hoisted_67 = { class: "col-lg-8 fv-row" }
const _hoisted_68 = { class: "row mb-6" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Descripción del modelo", -1)
const _hoisted_70 = { class: "col-lg-8 fv-row" }
const _hoisted_71 = { class: "row mb-6" }
const _hoisted_72 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Icono", -1)
const _hoisted_73 = { class: "col-lg-8 fv-row" }
const _hoisted_74 = { class: "row mb-6" }
const _hoisted_75 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Descripción de registro (JSON)", -1)
const _hoisted_76 = { class: "col-lg-8 fv-row" }
const _hoisted_77 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { class: "fw-bold" }, "Vista previa JSON:", -1)
const _hoisted_79 = { class: "bg-light p-2 rounded" }
const _hoisted_80 = { class: "language-json" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "mt-10" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Registrar Modelo")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("form", {
              id: "deviceForm",
              class: "form",
              novalidate: true,
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChangesDevice && _ctx.saveChangesDevice(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "macDevice",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Enter MAC device",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.macDevice = $event)),
                    onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.formatMac && _ctx.formatMac(...args))),
                    onPaste: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPasteMac && _ctx.onPasteMac(...args)), ["prevent"]))
                  }, null, 544), [
                    [_vModelText, _ctx.macDevice]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "wifiModuleDevice",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Enter Wifi Module",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.wifiModuleDevice = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.wifiModuleDevice]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedClientForDevice = $event))
                  }, [
                    _hoisted_15,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listClients, (client, idx) => {
                      return (_openBlock(), _createBlock("option", {
                        key: idx,
                        value: client
                      }, _toDisplayString(client.name), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedClientForDevice]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _withDirectives(_createVNode("select", {
                    siple: "",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedModel = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listModels, (model, index) => {
                      return (_openBlock(), _createBlock("option", {
                        key: index,
                        value: model
                      }, _toDisplayString(model.model), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedModel]
                  ])
                ])
              ]),
              _hoisted_19
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("form", {
              id: "clientForm",
              class: "form",
              novalidate: true,
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChangesClient && _ctx.saveChangesClient(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "clientName",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Enter client name",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.clientName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.clientName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "clientEmail",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Enter client email",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.clientEmail = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.clientEmail]
                  ])
                ])
              ]),
              _hoisted_31
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _hoisted_34,
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("form", {
              id: "distributorForm",
              class: "form",
              novalidate: true,
              onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChangesDistributor && _ctx.saveChangesDistributor(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("div", _hoisted_39, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "distributorName",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Enter distributor name",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.distributorName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.distributorName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode("div", _hoisted_42, [
                  _withDirectives(_createVNode("select", {
                    multiple: "",
                    class: "form-select",
                    style: {"height":"150px"},
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedClients = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listClients, (client, index) => {
                      return (_openBlock(), _createBlock("option", {
                        key: index,
                        value: client._id
                      }, _toDisplayString(client.name), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedClients]
                  ])
                ])
              ]),
              _hoisted_43
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_44, [
      _createVNode("div", _hoisted_45, [
        _hoisted_46,
        _createVNode("div", _hoisted_47, [
          _createVNode("div", _hoisted_48, [
            _createVNode("form", {
              class: "form",
              onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.associateDeviceWithClient && _ctx.associateDeviceWithClient(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode("div", _hoisted_51, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control mb-2",
                    placeholder: "Buscar MAC",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.deviceInput = $event)),
                    onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showDeviceOptions = true)),
                    onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideDeviceOptions && _ctx.hideDeviceOptions(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.deviceInput]
                  ]),
                  (_ctx.showDeviceOptions && _ctx.filteredDevices.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_52, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredDevices, (device) => {
                          return (_openBlock(), _createBlock("div", {
                            key: device.id,
                            class: "combo-item px-2 py-1",
                            style: {"cursor":"pointer"},
                            onMousedown: _withModifiers(($event: any) => (_ctx.selectDevice(device)), ["prevent"])
                          }, _toDisplayString(device.MAC), 41, ["onMousedown"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showDeviceOptions && !_ctx.filteredDevices.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_53, "Sin resultados"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode("div", _hoisted_56, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control mb-2",
                    placeholder: "Buscar cliente",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.clientInput = $event)),
                    onFocus: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showClientOptions = true)),
                    onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideClientOptions && _ctx.hideClientOptions(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.clientInput]
                  ]),
                  (_ctx.showClientOptions && _ctx.filteredClients.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_57, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredClients, (client) => {
                          return (_openBlock(), _createBlock("div", {
                            key: client.id,
                            class: "combo-item px-2 py-1",
                            style: {"cursor":"pointer"},
                            onMousedown: _withModifiers(($event: any) => (_ctx.selectClient(client)), ["prevent"])
                          }, _toDisplayString(client.name), 41, ["onMousedown"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showClientOptions && !_ctx.filteredClients.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_58, "Sin resultados"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_59
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_60, [
      _createVNode("div", _hoisted_61, [
        _hoisted_62,
        _createVNode("div", _hoisted_63, [
          _createVNode("div", _hoisted_64, [
            _createVNode("form", {
              id: "modelForm",
              class: "form",
              novalidate: "",
              onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveModel && _ctx.saveModel(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode("div", _hoisted_67, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "model",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Nombre del modelo",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.modelName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.modelName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_68, [
                _hoisted_69,
                _createVNode("div", _hoisted_70, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "deviceDescription",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Descripción del modelo",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.deviceDescription = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.deviceDescription]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_71, [
                _hoisted_72,
                _createVNode("div", _hoisted_73, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    name: "icon",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Icono",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.icon = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.icon]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_74, [
                _hoisted_75,
                _createVNode("div", _hoisted_76, [
                  _withDirectives(_createVNode("textarea", {
                    name: "registerDescription",
                    class: "form-control form-control-lg form-control-solid",
                    rows: 8,
                    placeholder: "Pega aquí el JSON",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.registerDescription = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.registerDescription]
                  ]),
                  (_ctx.registerDescription)
                    ? (_openBlock(), _createBlock("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode("pre", _hoisted_79, [
                          _createVNode("code", _hoisted_80, _toDisplayString(_ctx.formatJson(_ctx.registerDescription)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_81
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}